import { useTranslation } from "react-i18next";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export const SearchBar = ({ onChange }: { onChange: (v: string) => void }) => {
  const { t } = useTranslation("membersGroups");

  return (
    <div className="relative w-full sm:w-[300px]">
      {/* Icon */}
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />

      {/* Input */}
      <Input
        type="text"
        name="members-groups-search"
        autoComplete="off"
        placeholder={t("search.placeholder")}
        onChange={(e) => onChange(e.target.value)}
        className="h-10 pl-9" // space for icon
      />
    </div>
  );
};
